import React from "react";

const TeasePost = ({ idx, post }) => {
	return (
		<div className={`col-12 col-md-6 col-lg-3 mb-3`}>
			{post.thumbnail?.url && (
				<img
					src={post.thumbnail.url}
					alt={post.thumbnail.alt}
					srcSet={post.thumbnail.sizes
						.map((img) => `${img.url} ${img.size}`)
						.join(", ")}
					className="mb-2 w-100"
				/>
			)}
			<a
				className="d-block h4 text-dark"
				href={post.link}
				dangerouslySetInnerHTML={{
					__html: post.acf.title || post.title.rendered,
				}}
			></a>
			<div
				dangerouslySetInnerHTML={{
					__html: post.excerpt.rendered,
				}}
			/>
			<a href={post.link} className="c-button">
				<strong>Read More</strong>
			</a>
		</div>
	);
};

export default TeasePost;
